import { useMutation } from '@apollo/client';
import { Children, renderChildren } from '@sixfold/typed-render-props';
import React from 'react';

import { sortToGraphql } from './integrations_container';
import {
  DeleteTelematicsIntegrationMutation,
  DeleteTelematicsIntegrationMutationVariables,
  PAGINATION_PAGE_SIZE,
} from '../../lib/graphql';
import { useIntegrationListSort } from '../components/integration_list';
import { deleteTelematicsIntegrationMutation, telematicsIntegrationsListQuery } from '../graphql';

interface Props {
  companyId: string;
  children: Children<{
    deleteTelematicsIntegration: (telematicsIntegrationId: string) => Promise<void>;
  }>;
}

export const DeleteIntegrationMutation: React.FC<Props> = ({ companyId, children }) => {
  const { sort } = useIntegrationListSort();
  const [deleteIntegration] = useMutation<
    DeleteTelematicsIntegrationMutation,
    DeleteTelematicsIntegrationMutationVariables
  >(deleteTelematicsIntegrationMutation);

  return (
    <>
      {renderChildren(children as React.ReactNode, {
        deleteTelematicsIntegration: async (telematicsIntegrationId: string) => {
          return await deleteIntegration({
            refetchQueries: [
              {
                query: telematicsIntegrationsListQuery,
                variables: {
                  companyId,
                  limit: PAGINATION_PAGE_SIZE,
                  sort: sortToGraphql(sort),
                },
              },
            ],
            variables: {
              telematics_integration_id: telematicsIntegrationId,
            },
          });
        },
      })}
    </>
  );
};
